import { combineReducers } from 'redux';

import byId from './byId';
import allIds from './allIds';

export const getResidentialHistories = (state) => state.byId;
export const getResidentialHistory = (state, id) => state.byId[id];
export const getResidentialHistoryIds = (state) => state.allIds;

export default combineReducers({
  byId,
  allIds,
});
